import React from "react";
import OverviewSection from "@widgets/pos/orders/details/section/OverviewSection";
import {PlacedOrderOverview} from "@/data/entities/order";
import Overview from "@widgets/pos/orders/details/order/overview/Overview";
import Actions from "@widgets/pos/orders/details/order/actions/Actions";

type Props = {
    order: PlacedOrderOverview,
};

const Order = ({order}: Props) => {
    return (
        <OverviewSection>
            <Overview order={order}/>
            <Actions order={order}/>
        </OverviewSection>
    );
};

export default Order;